var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticStyle: { height: "100%" } }, [
    _c(
      "div",
      { staticClass: "zhwl-card flex" },
      _vm._l(_vm.qxzList, function (item, index) {
        return _c(
          "div",
          {
            key: index,
            staticClass: "row",
            class: _vm.isChoose === index ? "check" : "",
            on: {
              click: function ($event) {
                return _vm.rowClick(item, index)
              },
            },
          },
          [
            _c("div", { staticStyle: { color: "#01ceeb" } }, [
              _c("img", {
                staticStyle: { "vertical-align": "middle", margin: "0 auto" },
                attrs: { width: "20px", src: item.src },
              }),
              _vm._v(" " + _vm._s(item.name) + " "),
            ]),
            _c(
              "div",
              {
                staticClass: "flex",
                staticStyle: { "justify-content": "center" },
              },
              [
                _c(
                  "span",
                  {
                    staticClass: "num",
                    staticStyle: { "font-size": "17px" },
                    attrs: { id: "num" + index },
                  },
                  [_vm._v(" " + _vm._s(item.value ? item.value : "-") + " ")]
                ),
                _vm._v(" " + _vm._s(item.unit) + " "),
              ]
            ),
          ]
        )
      }),
      0
    ),
    _c(
      "div",
      { staticClass: "chartsBox" },
      [_c("loadEchart", { ref: "echarts" })],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }